import { ref, Ref } from "vue";
import { defineStore } from "pinia";
import { get_room_history_msg } from "@/network/socket/SocketReq";
import Platform from "@/config/platform";
import { Toast } from "vant";
import { copy } from "@/uitls/uitls";
import { msg_send_chatroom_msg } from "@/network/socket/SocketReq";
import { useI18n } from 'vue-i18n'
// const { t } = useI18n()

interface PlayerMessageListModel {
  viplevel: number;
  nickname: string;
  msgtype: number;
  content: string;
  uid: number;
  isadmin: number;
  chatmsgno: number;
  img: string;
  jumpUrl: string;
  title: string;
}

export const roomPiniaState = defineStore("room", () => {
  let roomPlayer = ref(false);
  //加入房间了没？
  const isJoin = ref(false);
  const roomId = ref(0);
  //tab的index
  const active = ref('chatroom');

  // Ref<Array<RoomModel>>
  const msgList: Ref<Array<PlayerMessageListModel>> = ref([]);

  const changeRoomPlayer = (type: boolean) => {
    roomPlayer.value = type;
    //如果是true,说明刚加入直播间成功

  };

  const changeIsjion = (type: boolean, id?: number) => {
    
    isJoin.value = type;
    //如果是true,说明刚加入直播间成功
    if (type) {
      roomId.value = id;
      //去获取聊天室记录
      get_room_history_msg(id);
    }
  };
  const changeroomID = (num: number) => {
    roomId.value = num;
  };

  const filterMsgItem = (item) => {
    if (item.msgtype == 22) {
      try {
        let content = JSON.parse(item.content);
        if (content && content.channel && content.channel) {
          let localChannel = Number(process.env.VUE_APP_CHANNEL);
          if (content.channel.indexOf(localChannel) >= 0) {
            item.content = content.content;
            return true;
          }
        }
      } catch (error) {
      }
      return false;
    }

    return true;
  }
  const addMsgList = (list: []) => {
    console.log(list);
    
    let arr = [];
    if (list && list.length > 0) {
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (filterMsgItem(item)) {
          arr.push(item);
        }
      }
    }
    msgList.value = arr;
  };
  //新增聊天室消息
  const addMsgItem = (data) => {
    if (!filterMsgItem(data)) {
      return;
    }
    const list = msgList.value;
    console.log(data);


    if (data.chatkey && data.chatkey.low && data.chatkey.low != 0) {
      if (roomId.value != data.chatkey.low) {
        console.log("==========直播间消息串了");
        return
      }
    }

    let temp = [data]
    //去重
    let result = temp.filter(function (item1) {
      return list.every(function (item2) {
        return item2.chatmsgno !== item1.chatmsgno
      })
    })
    if (result.length > 0) {
      msgList.value.push(data);
    }

  };

  //撤回直播间消息
  const delMsg = (index) => {
    let list = msgList.value;
    for (let i = 0; i < list.length; i++) {
      if (list[i].chatmsgno == index) {
        list.splice(i, 1);
        msgList.value = list;
      }
    }
  }


  //分享比赛
  const sharlMatch = async () => {
    const { t } = useI18n()
    copy(Platform.downUrl);
    Toast.success(t('tips.shareMatch'));
  };

  const cleanMsgList = () => {
    msgList.value = [];
  };

  const roomSendMsg = (value) => {
    msg_send_chatroom_msg(roomId.value, value);
  };
  //聊天广告
  const changeMsgAD = (val) => {
    let ad = {} as PlayerMessageListModel;
    ad.content = val.content;
    ad.img = val.img;
    ad.title = val.title;
    ad.jumpUrl = val.url
    ad.msgtype = val.msgtype || 1000;
    ad.chatmsgno = msgList.value.length > 0 ? (msgList.value[msgList.value.length - 1].chatmsgno + 0.5) : 0;

    msgList.value.push(ad);

    // let chat_ad_interval= localStorage.getItem('chat_ad_interval')
    // // 定义插入间隔
    // let interval = (parseInt(chat_ad_interval)||val.interval||8)+1;
    // let i=interval;
    // console.log(interval)

    // if(val.msgtype==999){
    //   // 在第一个位置插入数字
    //   // msgList.value.splice(0, 0, ad);
    //   // 每隔 8 个位置插入数字
    //   msgList.value.forEach((item, i) => {
    //     if (i % interval === 0) msgList.value.splice(i, 0, ad);
    //   });
    //   // for (i; i < msgList.value.length; i += interval) {
    //   //   msgList.value.splice(i, 0, ad);
    //   // }
    // }else{
    //   msgList.value.push(ad);
    // }
  }

  return {
    roomPlayer,
    changeRoomPlayer,
    changeIsjion,
    isJoin,
    roomId,
    addMsgList,
    sharlMatch,
    msgList,
    cleanMsgList,
    roomSendMsg,
    addMsgItem,
    delMsg,
    active,
    changeMsgAD
  };
});
